<template>
  <div class="location" :style="{ left: `calc(${left} - 10px)` }">
    <div>
      <!-- <van-icon name="location" size="30" /> -->

      <div class="triangleWrap">
        <div class="triangle"></div>
        <div class="triangle2"></div>
      </div>

      <span class="num">
        <span class="txt">&nbsp;&nbsp;{{ value }} </span>
        <span style="font-size:12px">{{ unit }}</span>
      </span>
    </div>
    <!-- <div class="point point_big"></div> -->
  </div>
</template>

<script>
export default {
  props: {
    left: {
      default: "0px"
    },
    value: {
      default: 0
    },
    unit: {
      default: ""
    }
  }
};
</script>

<style scoped lang="scss">
.triangleWrap {
  position: relative;
}

.triangle {
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 18px solid #ffffff; /* 设置三角形的颜色 */
  border-radius: 4px;
}

.triangle2 {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 13px solid red; /* 设置三角形的颜色 */
}

.point {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid #999999;
}

.location {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: -11px;
  left: -10px;
  z-index: 1000;

  .point_big {
    width: 14px;
    height: 14px;
    background: #1989fa;
    border-color: #1989fa;
    box-shadow: 0 0 5px 1px #1989fa;
  }

  .van-icon-location {
    color: #1989fa;
  }

  .num {
    position: absolute;
    top: -15px;
    right: -35px;
    width: 80px;
    text-align: center;
  }

  .txt {
    font-weight: bold;
  }
}

.easy_blue {
  .triangle2 {
    border-top-color: #409eff;
    color: #409eff;
  }

  .point_big {
    background: #409eff;
    border-color: #409eff;
    box-shadow: 0 0 5px 1px #409eff;
  }
}
.easy_green {
  .triangle2 {
    color: #67c23a;
    border-top-color: #67c23a;
  }
  .point_big {
    background: #67c23a;
    border-color: #67c23a;
    box-shadow: 0 0 5px 1px #e1f3d8;
  }
}
.easy_red {
  .triangle2 {
    color: #f56c6c;
    border-top-color: #f56c6c;
  }
  .point_big {
    background: #f56c6c;
    border-color: #f56c6c;
    box-shadow: 0 0 5px 1px #f56c6c;
  }
}

.easy_yellow {
  .triangle2 {
    border-top-color: rgba(255, 170, 0, 1);
    color: rgba(255, 170, 0, 1);
  }
  .point_big {
    background: rgba(255, 170, 0, 1);
    border-color: rgba(255, 170, 0, 1);
    box-shadow: 0 0 5px 1px rgba(255, 170, 0, 1);
  }
}
</style>
